export default "__VITE_ASSET__BQdBrumC__"